<template>
    <div id="wrapper" :key="valuekey">
        <div class="content-page">
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="page-title-box">
                                <h4 class="page-title">{{$t('string.msg.product.parts.label.title')}}</h4>

                            </div>
                        </div>
                    </div>
                    <!-- Form row -->
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card-box">
                                <p class="sub-header">
                                    {{$t('string.msg.product.parts.label.decription')}}
                                </p>

                                <form>
                                    <div v-if="data._id" class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.parts.label.id')}}
                                            </label>
                                            <input type="text" readonly v-model="data._id" class="form-control">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.company.label.status')}}
                                            </label>
                                            <select v-model="data.status" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option value="ACTIVE">{{$t('string.msg.active')}}</option>
                                                <option value="ARCHIVED">{{$t('string.msg.archived')}}</option>
                                            </select>
                                        </div>
                                    
                                        
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.parts.label.name')}}
                                            </label>
                                            <input type="text" v-model="data.name" class="form-control" :placeholder="$t('string.msg.product.parts.placeholder.name')">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.parts.label.status')}}
                                            </label>
                                            <select v-model="data.status" class="form-control">
                                                <option value="ACTIVE" selected>{{$t('string.msg.status.ACTIVE')}}</option>
                                                <option value="ARCHIVED">{{$t('string.msg.status.ARCHIVED')}}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t("string.msg.product.parts.label.group")}}
                                            </label>
                                            <select v-model="data.partGroup" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in groups" >{{camelize(item.name)}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t("string.msg.product.parts.label.family")}}
                                            </label>
                                            <select v-model="data.partFamily" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in families" >{{camelize(item.name)}}</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t("string.msg.product.parts.label.brand")}}
                                            </label>
                                            <select v-model="data.partBrand" class="form-control">
                                                <option value="-1" selected>{{$t('string.msg.element.select.selectitem')}}</option>
                                                <option :value="item._id" v-bind:key="item._id" v-for="item in brands" >{{camelize(item.name)}}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.parts.label.price')}}
                                            </label>
                                            <input v-money="money" id="salary" v-model="data.price" type="text" class="form-control" :placeholder="$t('string.msg.product.parts.placeholder.price')" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                <code class="highlighter-rouge">*</code>
                                                {{$t('string.msg.product.parts.label.description')}}
                                            </label>
                                            <br/>
                                            <textarea v-model="data.description" class="form-control" rows="3" :placeholder="$t('string.msg.product.parts.label.placeholder.description')"></textarea>
                                        </div>
                                        
                                        <!-- <div class="form-group col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.product.parts.label.upload.photo')}}
                                            </label>
                                            <br/>
                                            <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" class="form-control" >
                                            
                                        </div> -->
                                    </div>

                                    <!-- <div v-if="data.photoURL" class="form-row">
                                        <div class="form-group col-md-2">
                                            <label class="col-form-label">
                                                {{$t('string.msg.product.label.photo')}}
                                            </label>
                                            <div class="card border border-secondary">
                                                <div class="card-body text-secondary text-center">
                                                    <img v-bind:src="`${domain}${data.photoURL}`" alt="image" height="80" width="80">
                                                </div>
                                            </div>
                                        </div>    
                                    </div> -->

                                    <br/>
                                    <div class="d-flex justify-content-between bd-highlight mb-3">
                                        <button @click="clearForm" class="btn btn-secondary w-20">{{$t('string.msg.form.btn.clear')}}</button>
                                        <button @click="save" class="btn btn-danger w-20">{{$t('string.msg.form.btn.save')}}</button>
                                    </div>
                                    
                                    
                                </form>
                            </div>
                        </div>
                    </div>

                    <List v-on:load-item="selectItem"/>
                    
                </div>
            </div>
        </div>
        
        <Spinner />
        <Toast :title="titleToast" :message="messageToast" :messageId="messageIdToast" />
    </div>
</template>

<script>
import Controller from './CrtPart';

import Spinner from '../../../components/layout/Spinner';
import Toast from '../../../components/layout/Toast';

import List from './ListParts';

export default {
  name: 'Parts',
  components: {
    Spinner,
    Toast,
    List
  },
  data() {
      return {
        errors: [],
        groups: [],
        families: [],
        brands: [],
        valuekey: 0,
        titleToast: null,
        messageToast: null,
        messageIdToast: null,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            suffix: '',
            precision: 2,
            masked: false /* doesn't work with directive */
        },
        data: {
            status: "ACTIVE",
            name: null,
            partGroup: -1,
            partFamily: -1,
            partBrand: -1,
            price: null,
            photoURL: null,
            description: null
        }
      }
  },
  methods: Controller.methods,
  created() {
    Controller.init(this);
  },
  mounted(){
  }
}
</script>

<style>
</style>
